import cx from 'classnames';
import type React from 'react';

type OwnProps = {
  hasMargin?: boolean;
  hideIcon?: boolean;
  isMobile?: boolean;
  svgIcon: React.ReactNode;
};

export default function CTIcon({
  hideIcon = false,
  svgIcon,
  isMobile = false,
  hasMargin = false
}: OwnProps) {
  return (
    <div
      className={cx('ct-icon-revamp', {
        mobile: isMobile,
        'hide-icon': hideIcon,
        'with-margin': hasMargin
      })}
    >
      {svgIcon}
    </div>
  );
}
